export const preloadScript = (scripUrl) => {
  const script = document.createElement('link')
  script.href = scripUrl
  script.rel = 'preload'
  script.as = 'script'
  document.head.appendChild(script)
}

export const preloadTinyMCE = () => {
  preloadScript('https://assets-cdn-public.ahaslides.com/js/tinymce/5.10.9/tinymce.min.js')
  preloadScript('https://assets-cdn-public.ahaslides.com/js/tinymce/5.10.9/themes/silver/theme.min.js')
  preloadScript('https://assets-cdn-public.ahaslides.com/js/tinymce/5.10.9/icons/default/icons.min.js')
}
